import { Resource as s, API as a } from "@coveo/platform-client";
const t = class t extends s {
  list(e) {
    return this.api.get(
      this.buildPath(t.baseUrl, { trackingId: e })
    );
  }
};
t.baseUrl = `/rest/organizations/${a.orgPlaceholder}/commerce/private/audiences`;
let r = t;
export {
  r as Audiences
};
//# sourceMappingURL=Audiences.js.map
